import { AppState } from "@/mk2/reducers";

import {
    GroupsCategoryState,
    GroupsSearchState,
    ListOfGroupsPageState,
    initialGroupsCategoryState,
    initialQueryState,
} from "./ListOfGroups.reducers";

export const getListOfGroupsPageState = (state: AppState): ListOfGroupsPageState =>
    state.containers.groups.listOfGroups;

export const getListOfGroupsCategoryState = (
    state: AppState,
    category: string,
): GroupsCategoryState =>
    getListOfGroupsPageState(state).searches[category] || initialGroupsCategoryState;

export const getListOfGroupsSearchState = (
    state: AppState,
    category: string,
    query: string,
): GroupsSearchState => getListOfGroupsCategoryState(state, category)[query] || initialQueryState;
